import { render, staticRenderFns } from "./select-buji-item.vue?vue&type=template&id=55550e58&scoped=true&"
import script from "./select-buji-item.vue?vue&type=script&lang=js&"
export * from "./select-buji-item.vue?vue&type=script&lang=js&"
import style0 from "./select-buji-item.vue?vue&type=style&index=0&id=55550e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55550e58",
  null
  
)

export default component.exports